import React, { useState, useEffect, useRef } from 'react';
import './ChannelItem.css';

function ChannelItem({
  conversation,
  isSelected,
  onSelect,
  unreadCount = 0,
  onToggleFavorite,
  onToggleAI,
  onRename,
  onArchive,
  onLeave,
  onManageMembers,
  isOwner,
  isFavorited
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Close context menu on outside click
  useEffect(() => {
    if (!menuOpen) return;
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [menuOpen]);

  const title = conversation.title || 'untitled';

  return (
    <div className={`channel-item-row ${isSelected ? 'selected' : ''}`}>
      <button
        type="button"
        className={`channel-item ${unreadCount > 0 ? 'channel-item-unread' : ''}`}
        onClick={() => onSelect(conversation)}
        aria-pressed={isSelected}
      >
        <span className="channel-hash">#</span>
        <span className={`channel-name ${unreadCount > 0 ? 'channel-name-unread' : ''}`}>
          {title}
        </span>
        {conversation.aiEnabled && (
          <span className="channel-ai-indicator" aria-label="AI enabled" role="img">
            AI
          </span>
        )}
        {unreadCount > 0 && (
          <span className="unread-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
        )}
      </button>
      <div className="channel-item-actions" style={{ position: 'relative' }}>
        <button
          type="button"
          className="item-context-btn"
          onClick={(e) => {
            e.stopPropagation();
            setMenuOpen((o) => !o);
          }}
          aria-label={`Actions for #${title}`}
          title="More actions"
        >
          <svg viewBox="0 0 16 16" width="12" height="12" fill="currentColor">
            <path d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
          </svg>
        </button>
        {menuOpen && (
          <div className="context-menu" ref={menuRef} role="menu">
            {onToggleFavorite && (
              <button
                type="button"
                className="context-menu-item"
                role="menuitem"
                onClick={() => { setMenuOpen(false); onToggleFavorite(conversation.id); }}
              >
                {isFavorited ? 'Remove from Favorites' : 'Add to Favorites'}
              </button>
            )}
            {onRename && (
              <button
                type="button"
                className="context-menu-item"
                role="menuitem"
                onClick={() => { setMenuOpen(false); onRename(conversation); }}
              >
                Rename
              </button>
            )}
            {onManageMembers && isOwner && (
              <button
                type="button"
                className="context-menu-item"
                role="menuitem"
                onClick={() => { setMenuOpen(false); onManageMembers(conversation); }}
              >
                Manage members
              </button>
            )}
            {onLeave && !isOwner && (
              <button
                type="button"
                className="context-menu-item"
                role="menuitem"
                onClick={() => { setMenuOpen(false); onLeave(conversation); }}
              >
                Leave channel
              </button>
            )}
            {onToggleAI && conversation.type !== 'AI' && (
              <>
                <hr className="context-menu-separator" />
                <button
                  type="button"
                  className="context-menu-item context-menu-ai-toggle"
                  role="menuitemcheckbox"
                  aria-checked={!!conversation.aiEnabled}
                  onClick={() => {
                    setMenuOpen(false);
                    onToggleAI(conversation.id);
                  }}
                >
                  <span>{conversation.aiEnabled ? 'Disable AI' : 'Enable AI'}</span>
                  <span
                    className={`context-menu-ai-dot ${conversation.aiEnabled ? 'active' : ''}`}
                    aria-hidden="true"
                  />
                </button>
              </>
            )}
            {onArchive && (
              <button
                type="button"
                className="context-menu-item context-menu-item-danger"
                role="menuitem"
                onClick={() => {
                  setMenuOpen(false);
                  if (window.confirm(`Delete #${title}? This cannot be undone.`)) {
                    onArchive(conversation.id);
                  }
                }}
              >
                Delete
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ChannelItem;
